import { render, staticRenderFns } from "./CompareContainer.vue?vue&type=template&id=2ea15c9d&"
import script from "./CompareContainer.vue?vue&type=script&lang=js&"
export * from "./CompareContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports